// extracted by mini-css-extract-plugin
export default {"root":"SubmitError_root__Rt1Fk"};